import RenderedValue from './RenderedValue';
import { TemporaryCellValueContext } from './TemporaryCellValueProvider';
import { useContext } from 'react';

export default function OverrideableRenderedValue(props){

  let { temporaryCellValue } = useContext(TemporaryCellValueContext);


 
  let resolvedProps = {
    ...props
  }

  //console.log(props.textStyle);

  if( temporaryCellValue !== null && temporaryCellValue !== undefined ){
    resolvedProps.value = temporaryCellValue;
  }

  return <RenderedValue {...resolvedProps}/>

}
